import React, { useState } from "react";
import { Assets } from "utils/imports.utils";
import RoundIconButton from "common_components/ui/round_icon_button/round_icon_button.ui";
import { STRINGS } from "constants/strings.constant";
import { PreviewTargetFrameProps } from "interfaces/preview.interface";
import "./preview_target_frame.component.scss";

// The picture people point their phone at, held in four lime corner marks like a camera frame.
const PreviewTargetFrame = (props: PreviewTargetFrameProps): React.ReactElement => {
    const { images } = props;
    const [state, setState] = useState({ index: 0 });
    // The list can shrink or arrive after the first render.
    const index = Math.min(state.index, Math.max(images.length - 1, 0));
    const image = images[index];
    const hasSeveral = images.length > 1;

    const showTarget = (offset: number) => {
        setState({ index: (index + offset + images.length) % images.length });
    };

    return (
        <div className="preview_target_frame">
            <div className="preview_target_frame_surface">
                {image ? (
                    <div className="preview_target_frame_marks">
                        <img className="preview_target_frame_image" src={image} alt={STRINGS.preview.targetImageAlt} />
                        <span className="preview_target_frame_corner preview_target_frame_corner_top_left" aria-hidden="true" />
                        <span className="preview_target_frame_corner preview_target_frame_corner_top_right" aria-hidden="true" />
                        <span className="preview_target_frame_corner preview_target_frame_corner_bottom_left" aria-hidden="true" />
                        <span className="preview_target_frame_corner preview_target_frame_corner_bottom_right" aria-hidden="true" />
                    </div>
                ) : (
                    <p className="preview_target_frame_empty">{STRINGS.preview.noTargetImage}</p>
                )}
            </div>
            {hasSeveral && (
                <div className="preview_target_frame_pager">
                    <RoundIconButton
                        icon={Assets.arrow_left}
                        label={STRINGS.preview.previousTarget}
                        onClick={() => showTarget(-1)}
                    />
                    <span className="preview_target_frame_pager_count">{`${index + 1} / ${images.length}`}</span>
                    <RoundIconButton
                        icon={Assets.arrow_left}
                        label={STRINGS.preview.nextTarget}
                        isIconFlipped={true}
                        onClick={() => showTarget(1)}
                    />
                </div>
            )}
        </div>
    );
};

export default PreviewTargetFrame;
